module.exports = __webpack_public_path__ + "img/Itau.b25c701c.svg";